import React from 'react';
import moment from 'moment';
import RiskTag from '@gp/pages/StudioDashboard/StudioOverall/components/RiskTag';
import WrapableText from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/WrapableText';
import { toFirstUpperCase } from '@gp/utils/common';
import { RISKS_CONFIGS } from './constants';

import type { TableColumn } from 'tea-component';

// 获取Key Issues数据的最新更新时间
export const getLatestUpdateTimeOfKeyIssues = (keyIssues?: IStudioManagementKeyIssue[]): string => {
  if (!Array.isArray(keyIssues) || !keyIssues.length) return '';
  const times: moment.Moment[] = keyIssues.map((keyIssue) => moment(keyIssue?.create_time));
  const maxTime: moment.Moment = moment.max(times);
  return maxTime?.isValid() ? maxTime?.format('YYYY-MM-DD') : '';
};

export const getColumns = () => {
  const columns: TableColumn<IStudioManagementKeyIssue>[] = [
    {
      key: 'category',
      width: 230,
      align: 'left',
      header: 'Category',
      render: (cvm) => (
        <WrapableText className="dbg-word-break-word dbg-word-break-strong" text={toFirstUpperCase(cvm?.category)} />
      ),
    },
    {
      key: 'risk_rating',
      width: 150,
      align: 'left',
      header: 'Risk Rating',
      render: (cvm) => <RiskTag value={cvm?.risk_rating} configs={RISKS_CONFIGS} />,
    },
    {
      key: 'risk_challenge',
      align: 'left',
      header: 'Risk / Challenge',
      render: (cvm) => <WrapableText className="dbg-word-break-word" text={cvm?.risk_challenge} />,
    },
    {
      key: 'next_steps',
      align: 'left',
      header: 'Next Steps',
      render: (cvm) => <WrapableText className="dbg-word-break-word " text={cvm?.next_steps} />,
    },
  ];

  return columns;
};
